import React from 'react';

function PrivacyPolicy(props) {
    return (
        <div className='main-info'>
        <section class="privacy-policy">
        <h2>Privacy Policy</h2>

        <p>This Privacy Policy outlines how Cryptocurrency Hub ("we," "our," or "us") collects, uses, and protects your personal information when you use our website or application ("service"). By using our service, you agree to the terms outlined in this policy.</p>

        <h3>Information We Collect</h3>
        <p>We may collect the following types of information:</p>
        <ul>
            <li><strong>Personal Information:</strong> We may collect information such as your name, email address, and other details when you voluntarily provide it to us.</li>
            <li><strong>Usage Data:</strong> We may collect information about how you interact with our service, including pages visited, time spent on each page, and other analytical data.</li>
        </ul>

        <h3>How We Use Your Information</h3>
        <p>We use the collected information for the following purposes:</p>
        <ul>
            <li>To provide and maintain our service.</li>
            <li>To improve our service and user experience.</li>
            <li>To communicate with you, including responding to inquiries or providing updates.</li>
        </ul>

        <h3>Sharing Your Information</h3>
        <p>We do not sell, trade, or otherwise transfer your personal information to outside parties. However, we may share information with trusted third parties who assist us in operating our service, conducting our business, or serving you, as long as those parties agree to keep this information confidential.</p>

        <h3>Security</h3>
        <p>We take appropriate measures to protect your personal information. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>

        <h3>Changes to This Privacy Policy</h3>
        <p>We reserve the right to update or change our privacy policy at any time. Any changes will be effective immediately upon posting the updated policy on this page.</p>

    </section>

        </div>
    );
}

export default PrivacyPolicy;